"use client";
import Image from "next/image";
import MenuItem from "../MenuItem/MenuItem";
import useAutoClose from "@/hooks/useAutoClose";
import { useLoggedIn } from "@/store/useAuthStore";
// import CustomNavLink from "../CustomLink/CustomNavLink";
import useImageUrlModifier from "@/lib/useImageUrlModifier";
import { usePathname } from "next/navigation";

const LoginMenu = () => {
  const { tooglepopup, showPopup, ref, closepopup } = useAutoClose();
  const { auth, profile } = useLoggedIn();
  const modifyImageUrl = useImageUrlModifier();
  const pathname = usePathname();

  return (
    <div className="relative">
      {auth ? (
        <div className=" cursor-pointer" onClick={tooglepopup}>
          <Image
            className="hidden lg:block aspect-square rounded-full"
            src={modifyImageUrl(profile?.userImage, 100, 100) || "/images/user.svg"}
            width={28}
            height={28}
            alt="user"
          />
        </div>
      ) : 
      (
        // <CustomNavLink href="login" className=" cursor-pointer">
        //   <Image
        //     className="hidden lg:block rounded-full"
        //     src={"/images/user.svg"}
        //     width={28}
        //     height={28}
        //     alt="user"
        //   />
        // </CustomNavLink>
        <div onClick={() => {
          window.location.href = pathname?.split("/")[1] == "ar" ? "/ar/login" : "/en/login"
        }} className=" cursor-pointer">
          <Image
            className="hidden lg:block rounded-full"
            src={"/images/user.svg"}
            width={28}
            height={28}
            alt="user"
          />
        </div>
      )}

      {showPopup && (
        <div
          ref={ref}
          className={`absolute z-[1000] w-[300px] bg-white min-h-fit right-1/2  translate-x-5 ltr:lg:translate-x-1/4 rtl:translate-x-3/4 border`}
        >
          <MenuItem closepopup={closepopup} />
        </div>
      )}
    </div>
  );
};

export default LoginMenu;
